/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamRevisionLangMutationRequest,
  PostApiV1ExamRevisionLangMutationResponse,
  PostApiV1ExamRevisionLang400,
  PostApiV1ExamRevisionLang401,
  PostApiV1ExamRevisionLang404,
  PostApiV1ExamRevisionLang500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLang.ts";

function getPostApiV1ExamRevisionLangUrl() {
  const res = { method: "POST", url: `/api/v1/exam/revision/lang` as const };
  return res;
}

/**
 * @description Cria um novo idioma (ClassroomDisciplineBotExamLang) para a prova gerada por IA informada. Valida que a combinação BotExamId + CultureInfo ainda não existe antes de persistir. O status inicial do idioma criado é PendingReview. **(Requer Authorization para autenticação)**
 * @summary Criar idioma para prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang}
 */
export async function postApiV1ExamRevisionLang(
  data?: PostApiV1ExamRevisionLangMutationRequest,
  config: Partial<RequestConfig<PostApiV1ExamRevisionLangMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamRevisionLangMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLang400
      | PostApiV1ExamRevisionLang401
      | PostApiV1ExamRevisionLang404
      | PostApiV1ExamRevisionLang500
    >,
    PostApiV1ExamRevisionLangMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamRevisionLangUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
